import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import {BrowserRouter} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';

import './assets/styles/global.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <GoogleReCaptchaProvider
            reCaptchaKey="6LepA6cqAAAAAHya20xFJKsEjhnP8G1i-l4NOtbL">
            <BrowserRouter>
                <App/>
                <ToastContainer
                    position="top-right"
                    closeButton={false}
                    closeOnClick
                    rtl
                    draggable
                    pauseOnHover={false}
                    autoClose={3000}/>
            </BrowserRouter>

        </GoogleReCaptchaProvider>
    </React.StrictMode>
)
